var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { from, throwError } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map, switchMap, take } from 'rxjs/operators';
export var UNKNOWN_REQUEST_ERROR_MESSAGE = 'Unknown request error';
export var DEFAULT_SERVER_ERROR_MESSAGE = 'Server response with error';
var BODY_ENCODER;
(function (BODY_ENCODER) {
    BODY_ENCODER[BODY_ENCODER["json"] = 0] = "json";
    BODY_ENCODER[BODY_ENCODER["formData"] = 1] = "formData";
})(BODY_ENCODER || (BODY_ENCODER = {}));
var encodeToFormData = function (data) {
    return Object.keys(data && typeof data === 'object' ? data : {}).reduce(function (acc, key) {
        var value = data[key];
        if (value !== undefined) {
            acc.append(key, value);
        }
        return acc;
    }, new FormData());
};
var encodeBody = function (data, encoder) {
    switch (encoder) {
        case BODY_ENCODER.json:
            return JSON.stringify(data);
        case BODY_ENCODER.formData:
            return encodeToFormData(data);
        default:
            return data;
    }
};
var Request = /** @class */ (function () {
    function Request(token, requestManager, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var _a;
        this.prefix = ((options || {}).prefix || '').replace(/\/+$/, '');
        this.headers = (_a = (options || {}).headers) !== null && _a !== void 0 ? _a : {};
        this.execute = function (method, url, data, executeOptions) {
            return requestManager
                .run(function () {
                return from(token.getToken()).pipe(switchMap(function (accessToken) {
                    var body;
                    var contentType;
                    var encoderType = (executeOptions || {}).fileUpload
                        ? BODY_ENCODER.formData
                        : BODY_ENCODER.json;
                    if (data && !(executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.requestEncoder)) {
                        body = encodeBody(data, encoderType);
                    }
                    if (data && (executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.requestEncoder)) {
                        var encodedRequest = executeOptions.requestEncoder(data);
                        body = encodedRequest.data;
                        contentType = encodedRequest.contentType;
                    }
                    var config = {
                        body: body,
                        crossDomain: true,
                        headers: __assign(__assign({}, _this.headers), { Authorization: "Bearer " + accessToken, 'Content-Type': contentType || 'application/json' }),
                        method: method.toUpperCase(),
                        url: _this.createUrl(url)
                    };
                    if (encoderType === BODY_ENCODER.formData) {
                        delete config.headers['Content-Type'];
                    }
                    return ajax(config);
                }));
            })
                .pipe(map(function (result) { return ({
                data: result.response || null,
                meta: {
                    status: result.status
                }
            }); }), take(1), catchError(function (err) {
                // eslint-disable-next-line no-param-reassign
                err.displayMessage =
                    (err.status && err.response && err.response.message) ||
                        (err.status
                            ? DEFAULT_SERVER_ERROR_MESSAGE
                            : UNKNOWN_REQUEST_ERROR_MESSAGE);
                return throwError(err);
            }));
        };
    }
    Request.prototype.createUrl = function (url) {
        return this.prefix + "/" + url.replace(/^\/+/, '');
    };
    return Request;
}());
export { Request };
//# sourceMappingURL=Request.js.map